import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RouteService {

  constructor(private router: Router) {

  }

  login() {
    this.router.navigate([`login`]);
  }

  // Users
  userDetail(userId: number) {
    this.router.navigate([`users/${userId}`]);
  }
  userCreate() {
    this.router.navigate([`users/create`]);
  }
  userUpdate(userId: number) {
    this.router.navigate([`users/update/${userId}`]);
  }
  userList() {
    this.router.navigate([`users`]);
  }

  // Reservations
  reservationList() {
    this.router.navigate([`reservations`]);
  }
  reservationCreate() {
    this.router.navigate([`reservations/create`]);
  }
  reservationDetail(reservationId: number) {
    this.router.navigate([`reservations/${reservationId}`]);
  }
  reservationConfirm(reservationId: number) {
    this.router.navigate([`reservations/${reservationId}/confirm`]);
  }

  // Agencies
  agencyDetail(agencyId: number) {
    this.router.navigate([`agencies/${agencyId}`]);
  }
  agencyCreate() {
    this.router.navigate([`agencies/create`]);
  }
  agencyUpdate(agencyId: number) {
    this.router.navigate([`agencies/update/${agencyId}`]);
  }
  agencyList() {
    this.router.navigate([`agencies`]);
  }

  // Deposits
  depositByAgencyList(agencyId: number) {
    this.router.navigate([`deposits/agency/${agencyId}`]);
  }

  depositDetail(agencyId: number) {
    this.router.navigate([`deposits/${agencyId}`]);
  }
  depositCreate() {
    this.router.navigate([`deposits/create`]);
  }
  depositUpdate(agencyId: number) {
    this.router.navigate([`deposits/update/${agencyId}`]);
  }
  depositList() {
    this.router.navigate([`deposits`]);
  }

  // Deposits Vatican Museums

  depositMVDetail(depositMVId: number) {
    this.router.navigate([`deposit-mv/${depositMVId}`]);
  }

  depositMVList() {
    this.router.navigate([`deposit-mv`]);
  }

  // Availability
  availabilityDetail(availabilityId: number) {
    this.router.navigate([`availability/${availabilityId}`]);
  }
  availabilityCreate() {
    this.router.navigate([`availability/create`]);
  }
  availabilityUpdate(availabilityId: number) {
    this.router.navigate([`availability/update/${availabilityId}`]);
  }
  availabilityList() {
    this.router.navigate([`availability`]);
  }

}
